import { Descope } from '@descope/react-sdk';
import { Center, Stack, Title } from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Page404 } from './Page404';
import { sendDescopeErrorReport } from '../../utils/descope.utils';

export function Welcome() {
  const navigate = useNavigate();

  //Browser changes space to "+" in the URL, so we need to replace it space
  const displayName = decodeURIComponent(
    window.location.search.split('name=')[1]
  ).replace(/\+/g, ' ');

  if (displayName === 'undefined') {
    return <Page404 />;
  }

  return (
    <Stack>
      <Center>
        <Title order={1} className="auth-page-title">
          Welcome to {displayName}
        </Title>
      </Center>

      <Descope
        flowId="welcome-new-user"
        onSuccess={() => {
          navigate('/');
        }}
        logger={{
          debug: (title: string, description?: string) => {
            return;
          },
          info: (title, description, state) => {
            sendDescopeErrorReport(state, 'Framework > Welcome');
          },
          warn: () => {
            return;
          },
          error: () => {
            return;
          },
        }}
      />
    </Stack>
  );
}
